import { BrandOrDepartment, Variant } from "src/types";
import useRequest from "../useRequest";

export const useProductDetails = (id?: string | null) => {
  const url = `/products/${id}`;
  const { data, ...rest } = useRequest(!!id ? url : null, url);
  return {
    data: data as any,
    ...rest,
  };
};
